import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1000972-color_16c95abdfb__1600.jpg";
export const url = url_;